/* eslint-disable indent */
/* eslint-disable @typescript-eslint/camelcase */
/* eslint-disable no-useless-escape */
import i18n from 'i18n';
import { RolesEnum } from 'modules/authenticate/interfaces';
import * as Yup from 'yup';

export default (role?: RolesEnum, isEdit?: boolean) => {
  const saltSkip =
    isEdit && (role === 'superadmin' || role === 'admin')
      ? Yup.string().when('skip', {
          is: true,
          then: Yup.string()
            .required(i18n.t('REQUIRED_FIELD_KEY'))
            .nullable(true),
          otherwise: Yup.string().nullable(true),
        })
      : Yup.string();
  return Yup.object().shape({
    first_name: Yup.string()
      .required(i18n.t('REQUIRED_FIELD_KEY'))
      .max(
        64,
        i18n.t('MAX_LENGTH_KEY', {
          value: 64,
        })
      ),
    last_name: Yup.string()
      .required(i18n.t('REQUIRED_FIELD_KEY'))
      .max(
        64,
        i18n.t('MAX_LENGTH_KEY', {
          value: 64,
        })
      ),
    email: Yup.string()
      .email(i18n.t('EMAIL_INVALID_KEY'))
      .required(i18n.t('REQUIRED_FIELD_KEY')),
    fictitious_email: Yup.string().required(i18n.t('REQUIRED_FIELD_KEY')),
    ad_password_salt: Yup.object().shape({
      skip_reason: saltSkip,
    }),
  });
};
